import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dFunctor$dCompose from "../Data.Functor.Compose/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dValidation$dSemigroup from "../Data.Validation.Semigroup/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const FormErrors = x => x;
const Final = x => x;
const showFormErrors = /* #__PURE__ */ Data$dMap$dInternal.showMap(/* #__PURE__ */ (() => {
  const $0 = Data$dShow.showArrayImpl(Data$dShow.showStringImpl);
  return {
    show: v => {
      if (v.tag === "Just") { return "(Just " + $0(v._1) + ")"; }
      if (v.tag === "Nothing") { return "Nothing"; }
      $runtime.fail();
    }
  };
})())({
  show: /* #__PURE__ */ Data$dShow.showArrayImpl(/* #__PURE__ */ (() => {
    const $0 = Data$dShow.showArrayImpl(Data$dShow.showStringImpl);
    return record => {
      const v = Data$dShow.cons(Data$dShow.intercalate(": ")([
        "fieldLabel",
        (() => {
          if (record.fieldLabel.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(record.fieldLabel._1) + ")"; }
          if (record.fieldLabel.tag === "Nothing") { return "Nothing"; }
          $runtime.fail();
        })()
      ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
        "fieldName",
        (() => {
          if (record.fieldName.tag === "Just") { return "(Just " + $0(record.fieldName._1) + ")"; }
          if (record.fieldName.tag === "Nothing") { return "Nothing"; }
          $runtime.fail();
        })()
      ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["internal", record.internal ? "true" : "false"]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
        "message",
        Data$dShow.showStringImpl(record.message)
      ]))([]))));
      if (v.length === 0) { return "{}"; }
      return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v), "}"]);
    };
  })())
});
const semigroupFormErrors = {append: v => v1 => Data$dMap$dInternal.unionWith(Data$dMaybe.ordMaybe(Data$dOrd.ordArray(Data$dOrd.ordString)))(Data$dFunction.const)(v)(v1)};
const newtypeFormErrors_ = {Coercible0: () => {}};
const monoidFormErrors = {mempty: Data$dMap$dInternal.Leaf, Semigroup0: () => semigroupFormErrors};
const functorFinal = {map: f => v => Specular$dFRP$dBase.functorDynamic.map(Data$dEither.functorEither.map(f))(v)};
const eqFormErrors = /* #__PURE__ */ Data$dMap$dInternal.eqMap(/* #__PURE__ */ (() => {
  const $0 = Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl);
  return {
    eq: x => y => {
      if (x.tag === "Nothing") { return y.tag === "Nothing"; }
      if (x.tag === "Just") {
        if (y.tag === "Just") { return $0(x._1)(y._1); }
        return false;
      }
      return false;
    }
  };
})())({
  eq: /* #__PURE__ */ Data$dEq.eqArrayImpl(/* #__PURE__ */ (() => {
    const $0 = Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl);
    return ra => rb => (() => {
      if (ra.fieldLabel.tag === "Nothing") { return rb.fieldLabel.tag === "Nothing"; }
      if (ra.fieldLabel.tag === "Just") {
        if (rb.fieldLabel.tag === "Just") { return ra.fieldLabel._1 === rb.fieldLabel._1; }
        return false;
      }
      return false;
    })() && (() => {
      if (ra.fieldName.tag === "Nothing") { return rb.fieldName.tag === "Nothing"; }
      if (ra.fieldName.tag === "Just") {
        if (rb.fieldName.tag === "Just") { return $0(ra.fieldName._1)(rb.fieldName._1); }
        return false;
      }
      return false;
    })() && ra.internal === rb.internal && ra.message === rb.message;
  })())
});
const encodeFormErrors = /* #__PURE__ */ (() => (
  {
    encode: Data$dMap$dSerialized.encodeMap(Data$dMap$dSerialized.asJSONKeyMaybe({encode: Data$dFunctor.arrayMap(Unsafe$dCoerce.unsafeCoerce)})(Foreign$dGeneric$dClass.arrayDecode(Foreign$dGeneric$dClass.stringDecode)))({
      encode: Data$dFunctor.arrayMap(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "message"
      })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "internal"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({
        reflectSymbol: () => "fieldName"
      })((() => {
        const $0 = Data$dFunctor.arrayMap(Unsafe$dCoerce.unsafeCoerce);
        return {
          encodeWithOptions: v => v2 => {
            if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
            if (v2.tag === "Just") { return $0(v2._1); }
            $runtime.fail();
          }
        };
      })()))({reflectSymbol: () => "fieldLabel"})({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return v2._1; }
          $runtime.fail();
        }
      }).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions))
    })((() => {
      const $0 = Data$dFunctor.arrayMap(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "message"
      })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "internal"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({
        reflectSymbol: () => "fieldName"
      })((() => {
        const $0 = Data$dFunctor.arrayMap(Unsafe$dCoerce.unsafeCoerce);
        return {
          encodeWithOptions: v => v2 => {
            if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
            if (v2.tag === "Just") { return $0(v2._1); }
            $runtime.fail();
          }
        };
      })()))({reflectSymbol: () => "fieldLabel"})({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return v2._1; }
          $runtime.fail();
        }
      }).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions));
      return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", $0(v)), Data$dList$dTypes.Nil)};
    })()).encode
  }
))();
const decodeFormErrors = {
  decode: /* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dMaybe.ordMaybe(Data$dOrd.ordArray(Data$dOrd.ordString)))(Data$dMap$dSerialized.asJSONKeyMaybe({
      encode: Data$dFunctor.arrayMap(Unsafe$dCoerce.unsafeCoerce)
    })(Foreign$dGeneric$dClass.arrayDecode(Foreign$dGeneric$dClass.stringDecode)))(Foreign$dGeneric$dClass.arrayDecode({
      decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
        reflectSymbol: () => "message"
      })({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "internal"})({
        decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)
      })())({reflectSymbol: () => "fieldName"})((() => {
        const $0 = Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.arrayDecode(Foreign$dGeneric$dClass.stringDecode).decode);
        return {decodeWithOptions: v => $0};
      })())())({reflectSymbol: () => "fieldLabel"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
    }))((() => {
      const $0 = Foreign$dGeneric$dClass.arrayDecode({
        decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
          reflectSymbol: () => "message"
        })({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "internal"})({
          decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)
        })())({reflectSymbol: () => "fieldName"})((() => {
          const $0 = Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.arrayDecode(Foreign$dGeneric$dClass.stringDecode).decode);
          return {decodeWithOptions: v => $0};
        })())())({reflectSymbol: () => "fieldLabel"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
      });
      return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
    })()).decode;
    return x => {
      const $1 = $0(x);
      if ($1.tag === "Left") { return Data$dEither.$Either("Left", $1._1); }
      if ($1.tag === "Right") { return Data$dEither.$Either("Right", $1._1); }
      $runtime.fail();
    };
  })()
};
const applyFinal = /* #__PURE__ */ (() => {
  const $0 = Data$dValidation$dSemigroup.applyV(semigroupFormErrors);
  return {
    apply: v => v1 => Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map($0.apply)(v))(v1),
    Functor0: () => {
      const $1 = $0.Functor0();
      return {map: f => v => Specular$dFRP$dBase.functorDynamic.map($1.map(f))(v)};
    }
  };
})();
const applicativeFinal = /* #__PURE__ */ Data$dFunctor$dCompose.applicativeCompose(Specular$dFRP$dBase.applicativeDynamic)({
  pure: x => Data$dEither.$Either("Right", x),
  Apply0: () => Data$dValidation$dSemigroup.applyV(semigroupFormErrors)
});
const userVisibleErrors = errors => Data$dMap$dInternal.$$$Map(
  "Two",
  Data$dMap$dInternal.Leaf,
  Data$dMaybe.Nothing,
  Data$dFunctor.arrayMap(message => ({fieldName: Data$dMaybe.Nothing, fieldLabel: Data$dMaybe.Nothing, message, internal: false}))(errors),
  Data$dMap$dInternal.Leaf
);
const userVisibleError = message => Data$dMap$dInternal.$$$Map(
  "Two",
  Data$dMap$dInternal.Leaf,
  Data$dMaybe.Nothing,
  Data$dFunctor.arrayMap(message$1 => ({fieldName: Data$dMaybe.Nothing, fieldLabel: Data$dMaybe.Nothing, message: message$1, internal: false}))([message]),
  Data$dMap$dInternal.Leaf
);
const unFinalV = v => v;
const semigroupFinal = dictSemigroup => (
  {
    append: (() => {
      const $0 = dictSemigroup.append;
      return a => b => applyFinal.apply(applyFinal.Functor0().map($0)(a))(b);
    })()
  }
);
const monoidFinal = dictMonoid => ({mempty: applicativeFinal.pure(dictMonoid.mempty), Semigroup0: () => semigroupFinal(dictMonoid.Semigroup0())});
const makeFinalV = x => x;
const uniqFinal = dictMonadFRP => dictEq => {
  const $0 = dictMonadFRP.MonadCleanup1().Monad0().Bind1().Apply0().Functor0().map(makeFinalV);
  const $1 = Specular$dFRP$dBase.uniqDynBy(dictMonadFRP)(x => y => {
    if (x.tag === "Left") {
      if (y.tag === "Left") { return eqFormErrors.eq(x._1)(y._1); }
      return false;
    }
    if (x.tag === "Right") {
      if (y.tag === "Right") { return dictEq.eq(x._1)(y._1); }
      return false;
    }
    return false;
  });
  return x => $0($1(x));
};
const isEmpty = v => v.tag === "Leaf";
const internalErrorForField = fieldName => message => Data$dMap$dInternal.$$$Map(
  "Two",
  Data$dMap$dInternal.Leaf,
  Data$dMaybe.$Maybe("Just", fieldName),
  [{fieldName: Data$dMaybe.$Maybe("Just", fieldName), fieldLabel: Data$dMaybe.Nothing, message, internal: true}],
  Data$dMap$dInternal.Leaf
);
const internalError = message => Data$dMap$dInternal.$$$Map(
  "Two",
  Data$dMap$dInternal.Leaf,
  Data$dMaybe.Nothing,
  [{fieldName: Data$dMaybe.Nothing, fieldLabel: Data$dMaybe.Nothing, message, internal: true}],
  Data$dMap$dInternal.Leaf
);
const unknownError = /* #__PURE__ */ Data$dMap$dInternal.$$$Map(
  "Two",
  Data$dMap$dInternal.Leaf,
  Data$dMaybe.Nothing,
  [{fieldName: Data$dMaybe.Nothing, fieldLabel: Data$dMaybe.Nothing, message: "Unknown error", internal: true}],
  Data$dMap$dInternal.Leaf
);
const invalidFinal = /* #__PURE__ */ (() => {
  const n = Specular$dInternal$dIncremental.constant(Data$dEither.$Either("Left", unknownError));
  Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
  return n;
})();
const makeFinal = /* #__PURE__ */ (() => Specular$dFRP$dBase.functorDynamic.map(v2 => {
  if (v2.tag === "Nothing") { return Data$dEither.$Either("Left", unknownError); }
  if (v2.tag === "Just") { return Data$dEither.$Either("Right", v2._1); }
  $runtime.fail();
}))();
const liftDynamic = x => Specular$dFRP$dBase.functorDynamic.map(v2 => {
  if (v2.tag === "Nothing") { return Data$dEither.$Either("Left", unknownError); }
  if (v2.tag === "Just") { return Data$dEither.$Either("Right", v2._1); }
  $runtime.fail();
})(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(x));
const liftMaybe = x => Specular$dFRP$dBase.functorDynamic.map(v2 => {
  if (v2.tag === "Nothing") { return Data$dEither.$Either("Left", unknownError); }
  if (v2.tag === "Just") { return Data$dEither.$Either("Right", v2._1); }
  $runtime.fail();
})((() => {
  const n = Specular$dInternal$dIncremental.constant(x);
  Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
  return n;
})());
const heytingAlgebraFinal = dictHeytingAlgebra => (
  {
    ff: applicativeFinal.pure(dictHeytingAlgebra.ff),
    tt: applicativeFinal.pure(dictHeytingAlgebra.tt),
    implies: (() => {
      const $0 = dictHeytingAlgebra.implies;
      return a => b => applyFinal.apply(applyFinal.Functor0().map($0)(a))(b);
    })(),
    conj: (() => {
      const $0 = dictHeytingAlgebra.conj;
      return a => b => applyFinal.apply(applyFinal.Functor0().map($0)(a))(b);
    })(),
    disj: (() => {
      const $0 = dictHeytingAlgebra.disj;
      return a => b => applyFinal.apply(applyFinal.Functor0().map($0)(a))(b);
    })(),
    not: functorFinal.map(dictHeytingAlgebra.not)
  }
);
const hasFieldFinal = dictHasField => ({getField: label => functorFinal.map(dictHasField.getField(label))});
const fromValidV = v2 => {
  if (v2.tag === "Left") { return Data$dMaybe.Nothing; }
  if (v2.tag === "Right") { return Data$dMaybe.$Maybe("Just", v2._1); }
  $runtime.fail();
};
const unFinal = v => Specular$dFRP$dBase.functorDynamic.map(fromValidV)(v);
const uniqPureFinal = dictEq => {
  const $0 = Specular$dFRP$dBase.uniqDynPureBy(x => y => {
    if (x.tag === "Nothing") { return y.tag === "Nothing"; }
    if (x.tag === "Just") {
      if (y.tag === "Just") { return dictEq.eq(x._1)(y._1); }
      return false;
    }
    return false;
  });
  return x => Specular$dFRP$dBase.functorDynamic.map(v2 => {
    if (v2.tag === "Nothing") { return Data$dEither.$Either("Left", unknownError); }
    if (v2.tag === "Just") { return Data$dEither.$Either("Right", v2._1); }
    $runtime.fail();
  })($0(Specular$dFRP$dBase.functorDynamic.map(fromValidV)(x)));
};
const formErrorsToArray = /* #__PURE__ */ (() => {
  const $0 = Data$dArray.fromFoldableImpl(Data$dMap$dInternal.foldableMap.foldr);
  return x => Data$dArray.concat($0(x));
})();
const getErrors = /* #__PURE__ */ (() => Specular$dFRP$dBase.functorDynamic.map(v2 => {
  if (v2.tag === "Left") { return formErrorsToArray(v2._1); }
  if (v2.tag === "Right") { return []; }
  $runtime.fail();
}))();
const bindFinal = v => k => Specular$dFRP$dBase.bindDynamic.bind(v)(x => {
  if (x.tag === "Left") {
    const $0 = x._1;
    return (() => {
      const n = Specular$dInternal$dIncremental.constant(Data$dEither.$Either("Left", $0));
      Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
      return n;
    })();
  }
  if (x.tag === "Right") { return k(x._1); }
  $runtime.fail();
});
const additiveFinal = dictAdditive => (
  {
    zero: applicativeFinal.pure(dictAdditive.zero),
    add: (() => {
      const $0 = dictAdditive.add;
      return a => b => applyFinal.apply(applyFinal.Functor0().map($0)(a))(b);
    })(),
    sub: (() => {
      const $0 = dictAdditive.sub;
      return a => b => applyFinal.apply(applyFinal.Functor0().map($0)(a))(b);
    })()
  }
);
export {
  Final,
  FormErrors,
  additiveFinal,
  applicativeFinal,
  applyFinal,
  bindFinal,
  decodeFormErrors,
  encodeFormErrors,
  eqFormErrors,
  formErrorsToArray,
  fromValidV,
  functorFinal,
  getErrors,
  hasFieldFinal,
  heytingAlgebraFinal,
  internalError,
  internalErrorForField,
  invalidFinal,
  isEmpty,
  liftDynamic,
  liftMaybe,
  makeFinal,
  makeFinalV,
  monoidFinal,
  monoidFormErrors,
  newtypeFormErrors_,
  semigroupFinal,
  semigroupFormErrors,
  showFormErrors,
  unFinal,
  unFinalV,
  uniqFinal,
  uniqPureFinal,
  unknownError,
  userVisibleError,
  userVisibleErrors
};
